<admin-table-collapsable [items]="result">
  <ng-template #header>
    <th style="width: 10%">{{ 'pages.tables.last_runs.status' | translate }}</th>
    <th style="width: 10%">{{ 'pages.tables.last_runs.batch' | translate }}</th>
    <th style="width: 17%">{{ 'pages.tables.last_runs.channel' | translate }}</th>
    <th style="width: 10%">{{ 'pages.tables.last_runs.data' | translate }}</th>
    <th style="width: 10%">{{ 'pages.tables.last_runs.process' | translate }}</th>
    <th style="width: 17%">{{ 'pages.tables.last_runs.started' | translate }}</th>
    <th style="width: 17%">{{ 'pages.tables.last_runs.ended' | translate }}</th>
    <th style="width: 9%">&nbsp;</th>
  </ng-template>
  <ng-template #first let-item let-index="index" let-refid="refid">
    <td><div class="text-uppercase"><span [ngClass]="'status-badge-' + statusClass(item)" class="badge">{{ ('statuses.' + item.status) | translate}}</span></div></td>
    <td>{{item.batch}}</td>
    <td>{{item.owner}} / {{item.vertical}} / {{item.code}}</td>
    <td>{{item.data}}</td>
    <td>{{item.process}}</td>
    <td>{{item.started}}</td>
    <td>{{item.ended}}</td>
    <td class="justify-content-around text-end weight-label">
      <a (click)="report(item)" class="text-decoration-none action-buttons" data-bs-toggle="collapse" [attr.data-bs-target]="'#item' + refid + index" href="#">
        <i class="bi bi-info-square"></i>&nbsp;info
      </a>
    </td>
  </ng-template>
  <ng-template #second let-item>
    <admin-panel-inner>
      <admin-table-standard [items]="getReports()" [custom]="['inner-table']">
        <ng-template #header>
          <th style="width: 10%">{{ 'pages.tables.reports.status' | translate }}</th>
          <th style="width: 14%">{{ 'pages.tables.reports.batch' | translate }}</th>
          <th style="width: 23%">{{ 'pages.tables.reports.started' | translate }}</th>
          <th style="width: 23%">{{ 'pages.tables.reports.ended' | translate }}</th>
          <th style="width: 10%">{{ 'pages.tables.reports.ok' | translate }}</th>
          <th style="width: 10%">{{ 'pages.tables.reports.error' | translate }}</th>
          <th style="width: 10%">{{ 'pages.tables.reports.velocity' | translate }}</th>
        </ng-template>
        <ng-template #first let-item>
          <td>
            <span [ngClass]="{'text-success': item.status == 'SUCCESS', 'text-info': item.status == 'RUNNING', 'text-warning': item.status == 'ERRORS'}" class="badge fw-bolder">{{ ('statuses.' + item.status) | translate }} </span>
          </td>
          <td>{{item.batch}}</td>
          <td>{{item.started}}</td>
          <td>{{item.ended}}</td>
          <td>{{reportStats('ok', item)}}</td>
          <td>{{reportStats('error', item)}}</td>
          <td>{{reportStats('velocity', item).toFixed(2)}}</td>
        </ng-template>
      </admin-table-standard>
    </admin-panel-inner>
  </ng-template>
</admin-table-collapsable>
<div class="row d-flex justify-content-center p-2" *ngIf="all.length >= pageSize">
  <ngb-pagination class=""
                  [collectionSize]="all.length"
                  [(page)]="page"
                  [pageSize]="pageSize"
                  (pageChange)="paginate()"
  >
  </ngb-pagination>
</div>
